import "./Contact.css";

export default function Contact() {
  return (
    <div className="Contact_Container">
      <h2>Zero Four</h2>
      <p>Email: support@zerofour.tech</p>
      <br/>
      <h2>Alex Hixson</h2>
      <p>Email: hixsonaj@zerofour.tech</p>      
    </div>
    
  );
}